import { Language } from './language';
import { LanguageVariant } from './language-variant';

/** i18next `fallbackLng` per language. */
export const LANGUAGE_FALLBACKS: Record<string, string[]> = {
  [Language.CATALAN]: [LanguageVariant.SPANISH_SPAIN, Language.ENGLISH],
  default: [Language.ENGLISH],
};
